import { Button, Checkbox, Field, Input, Select } from '@itds/elements/index.js';
import React, { useContext, useState } from 'react';

import { ACTION_MESSAGES } from '@carrier/utils/custom_hooks/useNotification';
import Api from '@carrier/utils/Api';
import { CarrierContext } from '@carrier/contexts/CarrierContext';
import PropTypes from 'prop-types';

const General = ({ loadDataVersion, version }) => {
  const { setNotification } = useContext(CarrierContext);
  const [data, setData] = useState({
    cusip: version.cusip,
    beta: version.beta,
    date_gone_beta: version.date_gone_beta,
    date_gone_live: version.date_gone_live,
    live: version.live,
    name: version.product_name || '',
    premium_type: version.premium_type || '',
    is_proprietary: !!version.is_proprietary,
    internal_notes: version.internal_notes || ''
  });
  const [saving, setSaving] = useState(false);

  function handleInputChange(name, e) {
    const target = e?.target;
    const next =
      target && target.type === 'checkbox'
        ? target.checked
        : target
        ? target.value
        : e; 
    setData(prev => ({ ...prev, [name]: next }));
  }

  const handleSave = () => {
    setSaving(true);
    Api.updateAnnuityQuoteProduct(version.id, {
      product_name: data.name,
      cusip: data.cusip,
      internal_notes: data.internal_notes,
      is_proprietary: data.is_proprietary,
      premium_type: data.premium_type,
    }).then(() => {
      loadDataVersion();
      setSaving(false);
      setNotification(ACTION_MESSAGES.CARRIERS.LIFE_QUOTE.SAVE);
    });
  };

  return (
    <>
      <Field label='Name'>
        <Input onChange={handleInputChange.bind(null, 'name')} value={data.name} />
      </Field>

      <Field label='CUSIP'>
        <Input onChange={handleInputChange.bind(null, 'cusip')} value={data.cusip} />
      </Field>

      <Field label='Internal Notes'>
        <Input
          height={150}
          onChange={handleInputChange.bind(null, 'internal_notes')}
          type='textarea'
          value={data.internal_notes}
        />
      </Field>

      <Field label='Premium Type' style={{}}>
        <Select
          style={{}}
          onChange={handleInputChange.bind(null, 'premium_type')}
          options={[
            { value: '' },
            { value: 'Single' },
            { value: 'Flexible' },
          ]}
          value={data.premium_type.toLowerCase().includes('single') ? 'Single' : 
            data.premium_type.toLowerCase().includes('flexible') ? 'Flexible' : ''}
        />
      </Field>

      <Field label='Proprietary' style={{}}>
        <Checkbox
          onChange={handleInputChange.bind(null, 'is_proprietary')}
          checked={data.is_proprietary}
        ></Checkbox>
      </Field>

      <Button
        disabled={saving}
        icon={saving ? 'loading mdi-spin' : null}
        inline={true}
        onClick={handleSave}
      >
        {saving ? 'Saving...' : 'Save Changes'}
      </Button>
    </>
  );
};

General.propTypes = { loadDataVersion: PropTypes.func, version: PropTypes.object };

export default General;
